// extracted by mini-css-extract-plugin
module.exports = {"videoIframe":"_3jq2TH","videoBlockWrapper":"_2NM6d-"};